export const createCta = (options, products) => {
  const hostname = JSON.parse(
    document.querySelector(
      'script[type="application/json"][data-id="window.asos.siteChrome._initialStore"]'
    ).textContent
  ).regionalStore.storeUrls.default;

  return `<div class="cta-wrapper">
  <a 
    class="cta ${products.length === 0 ? "disabled" : ""}
    "
    ${
      products.length === 0
        ? `aria-disabled="true"`
        : `href="${hostname}cat/?cid=${options.categoryId}"`
    }
    target="${options.ctaTarget}"
    data-analyticsId="${options.analyticsId}"
  >
    ${options.ctaText.toUpperCase()}
  </a>
</div>`;
};
